import { authApi } from './core';
import { portfolioApi } from './portfolio';
import { bookingsApi } from './bookings';
import { clientsApi } from './clients';
import { galleriesApi } from './galleries';
import { leadsApi } from './leads';
import { packagesApi } from './packages';
import { invoicesApi } from './invoices';
import { pagesApi } from './pages';
import { analyticsApi } from './analytics';
import { accountApi } from './account';

export const api = {
  ...authApi,
  ...portfolioApi,
  ...bookingsApi,
  ...clientsApi,
  ...galleriesApi,
  ...leadsApi,
  ...packagesApi,
  ...invoicesApi,
  ...pagesApi,
  ...analyticsApi,
  ...accountApi,
};

export type { RuntimeConfig, Me } from './core';
export { ApiError } from './core';
export type { SocialLink, Portfolio, PortfolioTemplate, PortfolioUpdate } from './portfolio';
export type { BookingStatus, Booking, BookingActivity, BookingSettings, BookingLineItem, InquiryResult } from './bookings';
export type { Client, ClientMessage } from './clients';
export type { Gallery, GalleryUpdate, GalleryAsset, AssetStub, PublishResult, ProofingComment, ProofingAssetResult, ProofingResults } from './galleries';
export type { Lead } from './leads';
export type { Package } from './packages';
export type { InvoiceLine, InvoiceStatus, Invoice } from './invoices';
export type { BlockType, Block, BlockContent, Page, PageTemplate } from './pages';
export type { DayCount, GalleryAnalytics, TopGallery, AnalyticsSummary } from './analytics';
export type { UserTheme, InvoiceSettings } from './account';
